/**
 * Save or Discard Dialog Component
 * 
 * Three-choice dialog for unsaved changes scenarios:
 * - Save: Save changes before proceeding
 * - Discard: Abandon changes and proceed
 * - Cancel (X or outside click): Stay and continue editing
 * 
 * Used by useFeedback().confirm.saveOrDiscard for unsaved changes prompts.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./alert-dialog";
import { Button } from "./button";

export type SaveOrDiscardResult = 'save' | 'discard' | null;

export interface SaveOrDiscardDialogProps {
  open: boolean;
  title: string;
  message: string;
  saveText: string;
  discardText: string;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export const SaveOrDiscardDialog = ({
  open,
  title,
  message,
  saveText,
  discardText,
  onSave,
  onDiscard,
  onCancel,
}: SaveOrDiscardDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col-reverse sm:flex-row gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={onDiscard}
            className="sm:mr-auto"
          >
            {discardText}
          </Button>
          <Button
            variant="default"
            onClick={onSave}
          >
            {saveText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export interface SaveOrDiscardOptions {
  title: string;
  message: string;
  saveText: string;
  discardText: string;
}
